module.exports = __webpack_public_path__ + "static/media/loader-legal.9ee563de.gif";